import {Link} from 'gojs';

import {APPLICATION_GRAPH_NODE_RADIUS} from 'src/util/gojs/constants';
import {toCartesian} from 'src/util/graph';

const {PI} = Math;

export class FixedRadiusParallelRouteLink extends Link {
  constructor() {
    super();
  }

  computePoints() {
    const result = super.computePoints();
    if (!this.isOrthogonal) {
      const curv = this.computeCurviness();

      if (curv !== 0) {
        let num = this.pointsCount;
        if (num > 2) {
          if (num % 2 === 0) {
            this.removePoint((num / 2));
            this.removePoint((num / 2) - 1);
          } else {
            this.removePoint(Math.floor(num / 2));
          }
        }

        num = this.pointsCount;
        let pidx = 0;
        let qidx = num - 1;

        // Magic...?
        if (num >= 4) {
          pidx++;
          qidx--;
        }

        const extraAngle = this.hasCurviness() ? (curv < 0 ? -0.8 : 0.8) * Math.abs(curv) : 0;

        const fromPoint = this.getPoint(pidx);
        const toPoint = this.getPoint(qidx);

        const theta = fromPoint.directionPoint(toPoint);
        const [px, py] = toCartesian(APPLICATION_GRAPH_NODE_RADIUS, ((theta + extraAngle) / 180) * PI);
        this.insertPointAt(pidx + 1, px + fromPoint.x, py + fromPoint.y);

        const iota = toPoint.directionPoint(fromPoint);
        const [qx, qy] = toCartesian(APPLICATION_GRAPH_NODE_RADIUS, (((iota + (extraAngle * -1)) / 180) * PI));
        this.insertPointAt(qidx + 1, qx + toPoint.x, qy + toPoint.y);
      }
    }
    return result;
  }
}
